import React from "react";
import Input from "components/bootstrap/Input";
import { getValueFromInput } from "util/FormsUtils";
import { optionableLabel } from "components/configurationforms/FieldHelpers";
const NumberField = ({ autoFocus = false, field, onChange, title, typeName, value = 0 }) => {
  const _getDefaultValidationSpecs = () => ({ min: Number.MIN_SAFE_INTEGER, max: Number.MAX_SAFE_INTEGER });
  const _mapValidationAttribute = (attribute) => {
    const { min, max } = _getDefaultValidationSpecs();
    switch (attribute.toUpperCase()) {
      case "ONLY_NEGATIVE":
        return { min, max: -1 };
      case "ONLY_POSITIVE":
        return { min: 0, max };
      case "IS_PORT_NUMBER":
        return { min: 0, max: 65535 };
      default:
        return { min, max };
    }
  };
  const validationSpec = () => {
    const validationAttributes = field.attributes.map(_mapValidationAttribute);
    if (validationAttributes.length > 0) {
      return validationAttributes[0];
    }
    return _getDefaultValidationSpecs();
  };
  const handleChange = ({ target }) => {
    const numericValue = getValueFromInput(target);
    onChange(title, Number(numericValue));
  };
  const isRequired = !field.is_optional;
  const validationSpecs = validationSpec();
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${typeName}-${title}`,
      label: optionableLabel(field),
      type: "number",
      name: `configuration[${title}]`,
      required: isRequired,
      onChange: handleChange,
      value: value || 0,
      help: field.description,
      ...validationSpecs,
      autoFocus
    }
  );
};
export default NumberField;
